import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';


@Component({
  selector: 'app-facegate-report-config',
  templateUrl: './facegate-report-config.component.html',
  styleUrls: ['./facegate-report-config.component.css']
})
export class FacegateReportConfigComponent implements OnInit {

    public items: MenuItem[];
    public arrotondamenti: any[];
    public arrChosen: String;

  constructor(
    private router: Router
  ) {
    this.arrotondamenti = [
      {label:'Nessun Arrotondamento', value:null},
      {label:'5 minuti', value:"5"},
      {label:'10 minuti', value:"10"},
      {label: '15 minuti', value:"15"}
    ]
  }

  ngOnInit() {
    this.loadServicesMenu();

  }

  loadServicesMenu() {
    this.items = [
      {
        label: 'DATI',
        items: [
          {label: 'I miei dati', icon: 'pi pi-fw pi-file', routerLink: ['/home']},
          {label: 'La mia sottoscrizione', icon: 'pi pi-fw pi-dollar', routerLink: ['/payFacegate']}
        ]
      },
      {
        label: 'SERVIZI',
        items: [
          {label: 'Registro foto', icon: 'pi pi-fw pi-camera', routerLink: ['/photosFacegate']},
          {label: 'Dati riepilogativi', icon: 'pi pi-fw pi-users', routerLink: ['/reportsFacegate']},
          {label: 'Configurazione', icon: 'pi pi-fw pi-cog'}
        ]
      }
    ];
  }

}
